

const Upload = () => {
  return (
    <div>
      <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_1010_897)">
<rect x="2.5" y="1" width="40" height="40" rx="8" fill="white"/>
<rect x="3" y="1.5" width="39" height="39" rx="7.5" stroke="#EAECF0"/>
<path d="M19.1667 24.3333L22.5 21M22.5 21L25.8333 24.3333M22.5 21V28.5M29.1667 24.9524C30.1846 24.1117 30.8333 22.8399 30.8333 21.4167C30.8333 18.8854 28.7813 16.8333 26.25 16.8333C26.0679 16.8333 25.8975 16.7383 25.8051 16.5814C24.7184 14.7374 22.712 13.5 20.4167 13.5C16.9649 13.5 14.1667 16.2982 14.1667 19.75C14.1667 21.4718 14.8629 23.0309 15.9891 24.1613" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_1010_897" x="0.5" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1010_897"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1010_897" result="shape"/>
</filter>
</defs>
</svg>

    </div>
  )
}

export default Upload
